import React from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const Slider1 = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (

        <div>


            <div style={{ marginTop: "30px", marginBottom: "-200px"}}>
            <div
                    className=""
                    data-width={6}
                >
                    <div className="rowItemContent responsive_more_product">
                        <header className="header btClear large btDash bottomDash  ">
                            <div class="dash sl1"><h2><span class="headline" style={{ color: "black" }}> More Products</span>
                            </h2></div>

                            <div className="btSubTitle responsive_more_paragrapgh sl2" >
                                "Get a closer look at our products through the eyes of our customers on our review page. From in-depth analyses to hands-on experiences, our reviews offer a firsthand perspective to help you make informed choices."{" "}
                            </div>
                        </header>
                        <div className="btClear btSeparator topSemiSpaced noBorder">
                            <hr />
                        </div>
                    </div>
                </div>
                <Slider {...settings} className="my-slider" >
                    <div className="bclItem">
                        <div className="bclItemChild">
                            <div className="bclItemChildContent">
                                <div className="bpgPhoto btZoomInHoverType">
                                    <a href="/products" target="_self" title="" tabIndex="-1"></a>
                                    <div className="boldPhotoBox">
                                        <div className="bpbItem">
                                            <div className="btImage " style={{height:"240px"}}>
                                                <img 
                                                    decoding="async"
                                                    src="./Images/p12.jpg"
                                                    alt=""
                                                    title="View Product"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="captionPane btDarkSkin btTextCenter">
                                        <div className="captionTable">
                                            <div className="captionCell">
                                                <div className="captionTxt">
                                                    <header className="header btClear extrasmall">
                                                        <div className="btSuperTitle">
                                                            <span>View Product</span>
                                                        </div>
                                                    </header>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bclItem">
                        <div className="bclItemChild">
                            <div className="bclItemChildContent">
                                <div className="bpgPhoto btZoomInHoverType">
                                    <a href="/products" target="_self" title="" tabIndex="-1"></a>
                                    <div className="boldPhotoBox">
                                        <div className="bpbItem">
                                            <div className="btImage" style={{height:"240px"}}>
                                                <img  
                                                    decoding="async"
                                                    src="./Images/fs2.jpg"
                                                    alt=""
                                                    title="View Product"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="captionPane btDarkSkin btTextCenter">
                                        <div className="captionTable">
                                            <div className="captionCell">
                                                <div className="captionTxt">
                                                    <header className="header btClear extrasmall">
                                                        <div className="btSuperTitle">
                                                            <span>View Product</span>
                                                        </div>
                                                    </header>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bclItem">
                        <div className="bclItemChild">
                            <div className="bclItemChildContent">
                                <div className="bpgPhoto btZoomInHoverType">
                                    <a href="/product" target="_self" title="" tabIndex="-1"></a>
                                    <div className="boldPhotoBox">
                                        <div className="bpbItem">
                                            <div className="btImage" style={{height:"240px"}}>
                                                <img 
                                                    decoding="async"
                                                    src="./Images/c2.jpg"
                                                    alt=""
                                                    title="View Product"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="captionPane btDarkSkin btTextCenter">
                                        <div className="captionTable">
                                            <div className="captionCell">
                                                <div className="captionTxt">
                                                    <header className="header btClear extrasmall">
                                                        <div className="btSuperTitle">
                                                            <span>View Product</span>
                                                        </div>
                                                    </header>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bclItem">
                        <div className="bclItemChild">
                            <div className="bclItemChildContent">
                                <div className="bpgPhoto btZoomInHoverType">
                                    <a href="/product" target="_self" title="" tabIndex="-1"></a>
                                    <div className="boldPhotoBox">
                                        <div className="bpbItem">
                                            <div className="btImage" style={{height:"240px"}}>
                                                <img 
                                                    decoding="async"
                                                    src="./Images/ps17.jpg"
                                                    alt=""
                                                    title="View Product"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="captionPane btDarkSkin btTextCenter">
                                        <div className="captionTable">
                                            <div className="captionCell">
                                                <div className="captionTxt">
                                                    <header className="header btClear extrasmall">
                                                        <div className="btSuperTitle">
                                                            <span>View Product</span>
                                                        </div>
                                                    </header>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bclItem">
                        <div className="bclItemChild">
                            <div className="bclItemChildContent">
                                <div className="bpgPhoto btZoomInHoverType">
                                    <a href="/product" target="_self" title="" tabIndex="-1"></a>
                                    <div className="boldPhotoBox">
                                        <div className="bpbItem">
                                            <div className="btImage" style={{height:"240px"}}>
                                                <img 
                                                    decoding="async"
                                                    src="./Images/pc12.jpg"
                                                    alt=""
                                                    title="View Product"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="captionPane btDarkSkin btTextCenter">
                                        <div className="captionTable">
                                            <div className="captionCell">
                                                <div className="captionTxt">
                                                    <header className="header btClear extrasmall">
                                                        <div className="btSuperTitle">
                                                            <span>View Product</span>
                                                        </div>
                                                    </header>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="bclItem">
                        <div className="bclItemChild">
                            <div className="bclItemChildContent">
                                <div className="bpgPhoto btZoomInHoverType">
                                    <a href="/product" target="_self" title="" tabIndex="-1"></a>
                                    <div className="boldPhotoBox">
                                        <div className="bpbItem">
                                            <div className="btImage">
                                                <img
                                                    decoding="async"
                                                    src="./Images/ps15.jpg"
                                                    alt=""
                                                    title="View Product"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="captionPane btDarkSkin btTextCenter">
                                        <div className="captionTable">
                                            <div className="captionCell">
                                                <div className="captionTxt">
                                                    <header className="header btClear extrasmall">
                                                        <div className="btSuperTitle">
                                                            <span>View Product</span>
                                                        </div>
                                                    </header>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="bclItem">
                        <div className="bclItemChild">
                            <div className="bclItemChildContent">
                                <div className="bpgPhoto btZoomInHoverType">
                                    <a href="/product" target="_self" title="" tabIndex="-1"></a>
                                    <div className="boldPhotoBox">
                                        <div className="bpbItem">
                                            <div className="btImage " style={{height:"240px"}}>
                                                <img 
                                                    decoding="async"
                                                    src="./Images/ps15.jpg"
                                                    alt=""
                                                    title="View Product"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="captionPane btDarkSkin btTextCenter">
                                        <div className="captionTable">
                                            <div className="captionCell">
                                                <div className="captionTxt">
                                                    <header className="header btClear extrasmall">
                                                        <div className="btSuperTitle">
                                                            <span>View Product</span>
                                                        </div>
                                                    </header>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bclItem">
                        <div className="bclItemChild">
                            <div className="bclItemChildContent">
                                <div className="bpgPhoto btZoomInHoverType">
                                    <a href="/product" target="_self" title="" tabIndex="-1"></a>
                                    <div className="boldPhotoBox">
                                        <div className="bpbItem">
                                            <div className="btImage" style={{height:"240px"}}>
                                                <img 
                                                    decoding="async"
                                                    src="./Images/fs1.jpg"
                                                    alt=""
                                                    title="View Product"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="captionPane btDarkSkin btTextCenter">
                                        <div className="captionTable">
                                            <div className="captionCell">
                                                <div className="captionTxt">
                                                    <header className="header btClear extrasmall">
                                                        <div className="btSuperTitle">
                                                            <span>View Product</span>
                                                        </div>
                                                    </header>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Add more slider items here */}
                </Slider>
            </div>
        </div>
    )
}

export default Slider1
